<script>
import { Icon } from "@iconify/vue2";

export default {
  components: {
    Icon
  },
  props: {
    type: {
      type: String,
      required: false,
      default: "text"
    },
    label: {
      type: String,
      required: false,
      default: "Enter value"
    },
    value: {
      required: false
    },
    modelValue: {
      type: [String, Number],
      required: false
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    maxLength: {
      type: [String, Number],
      required: false
    },
    max: {
      type: [String, Number],
      required: false,
      default: 999999999999
    },
    min: {
      type: [String, Number],
      required: false,
      default: 0
    },
    locale: {
      type: String,
      required: false,
      default: "de"
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      required: false
    },
    cols: {
      type: [Number, String],
      required: false,
      default: 30
    },
    rows: {
      type: [Number, String],
      required: false,
      default: 10
    },
    textareaDisableNewLine: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    bind: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isFocused: false,
      showPass: false,
      id: null,
      textareaPadding: 16,
      textareaMinHeight: 50
    };
  },
  computed: {
    val() {
      if (this.modelValue) {
        return this.modelValue;
      }
      return this.value;
    },
    max_len() {
      if (this.maxLength) {
        return Number(this.maxLength);
      }
      if (this.type === "textarea") {
        return 1100; // Default max length for textarea
      }
      return 255;
    }
  },
  methods: {
    onBlur(e) {
      this.isFocused = false;
      this.$emit("blur", e);
    },
    generateRandomId() {
      this.id = `input-${Math.random()
        .toString(36)
        .substring(2, 9)}`;
    },
    inputValue(e) {
      if (e.target.value.length > this.max_len) {
        e.target.value = this.val;
        return;
      }
      this.$emit("update:modelValue", e.target.value, e);
      this.$emit("input", e.target.value, e);
    },
    currencyChange(e) {
      this.$emit("change", e);
    },
    updateLabelHeight() {
      this.$nextTick(() => {
        if (this.$refs.myLabel) {
          this.labelHeight = this.$refs.myLabel.offsetHeight || 20;
        }
      });
    },
    focusInput() {
      this.$refs.myInput.focus();
    },
    handleTextareaKeydown(e) {
      if (this.textareaDisableNewLine && e.key === "Enter") {
        e.preventDefault();
      }
      this.$emit("keydown", e);
    }
  },

  mounted() {
    this.generateRandomId();
    this.$nextTick(() => {
      const labelHeight = this.$refs.myLabel.offsetHeight;
      // const labelWeigth = this.$refs.myLabel.offsetWeigth;
      this.textareaPadding = labelHeight < 26 ? 20 : labelHeight;
      this.textareaMinHeight = labelHeight + 50;
    });
  }
};
</script>
<template>
  <!-- float -->
  <div
    class="input-wrapper"
    :class="{ error: error, 'textarea-wrapper': type === 'textarea', disabled }"
  >
    <textarea
      v-if="type === 'textarea'"
      v-bind="bind"
      :style="{
        'padding-top':
          $refs.myLabel && $refs.myLabel.offsetHeight
            ? $refs.myLabel.offsetHeight + 'px'
            : 20 + 'px',
        'min-height': textareaMinHeight + 'px',
        resize: 'none'
      }"
      ref="myInput"
      :value="val"
      @input="inputValue"
      @focus="isFocused = true"
      @blur="onBlur"
      @keydown="handleTextareaKeydown"
      :class="{
        filled: isFocused || (val && val.length > 1),
        'full-height': fullHeight
      }"
      :id="id"
      placeholder=" "
      :cols="cols"
      :rows="rows"
      :disabled="disabled"
    ></textarea>
    <currency-input
      v-else-if="type === 'currency-input'"
      v-bind="bind"
      :label="$t('profile.purchase.quantity') + '*'"
      :locale="locale"
      :currency="null"
      :disabled="disabled"
      :value="val"
      :precision="0"
      maxlength="9"
      class="input"
      @change="currencyChange"
      @focus="isFocused = true"
      @blur="onBlur"
      placeholder=" "
    />
    <input
      v-else
      v-bind="bind"
      ref="myInput"
      :type="type !== 'password' ? type : showPass ? 'text' : 'password'"
      :value="val"
      @input="inputValue"
      @focus="isFocused = true"
      @blur="onBlur"
      @keydown="$emit('keydown', $event)"
      @keyup="$emit('keyup', $event)"
      :class="{ filled: isFocused || val }"
      :id="id"
      :disabled="disabled"
      placeholder=" "
      :max="max"
      :min="min"
    />
    <label
      :class="{
        floated: isFocused || val || val === 0,
        inputLabel: type === 'text',
        disabled,
        itallic: type === 'textarea'
      }"
      :style="{
        'padding-right': $refs.charCount
          ? $refs.charCount.offsetWidth + 'px'
          : 0
      }"
      :for="id"
      ref="myLabel"
      >{{ label }}</label
    >
    <!-- <label :class="{ floated: isFocused || val, disabled }" :for="id">{{
      label
    }}</label> -->
    <img
      v-if="type === 'password' && !disabled"
      @click="showPass = !showPass"
      class="pass-img"
      :src="
        showPass
          ? require('@/assets/newImges/eye.svg')
          : require('@/assets/newImges/eye-cross.svg')
      "
    />
    <Icon v-if="icon && type !== 'password'" class="icon" :icon="icon" />
    <div v-if="type === 'textarea'" class="char-count" ref="charCount">
      {{ val ? val.length : 0 }} / {{ max_len }}
    </div>
  </div>
</template>
<style scoped lang="scss">
/* FLOAT */
/*
This solution uses a placeholder=" " trick to allow styling without interference.

The label is inside the input by default, but floats above on focus or if text exists.

No external CSS frameworks or plugins needed — works in old Vue apps too
*/
.input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  &.disabled {
    background-color: $gray-blue-600;
  }
}
.char-count {
  position: absolute;
  top: 4px;
  right: 8px;
  font-size: 12px;
  color: $gray-blue-1300;
}

.input-wrapper input,
.input-wrapper textarea,
.input-wrapper .input {
  width: 100%;
  padding: 16px 12px 4px;
  box-sizing: border-box;
  height: 50px;
  // padding: 0 12px;
  border: 1px solid $gray-blue-700;
  border-radius: 8px;
  background-color: $gray-blue-100;

  outline: none;

  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  color: $blue-1000;
  &[disabled] {
    background-color: $gray-blue-600;
  }
}

.input-wrapper input[type="password"] {
  padding-right: 40px;
}
.input-wrapper.error input,
.input-wrapper.error .input,
.input-wrapper.error textarea {
  border-color: $red-600;
}

.input-wrapper textarea {
  padding-top: 20px;
  height: 150px;
  &.full-height {
    height: 100%;
  }
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
}

.input-wrapper label {
  text-align: left;
  position: absolute;
  left: 12px;
  top: 14px;
  color: $blue-300; /* gray-500  original: $light-blue-1000*/
  font-size: 16px;

  pointer-events: none;
  transition: 0.2s ease all;
  background-color: transparent;

  padding: 0;
  width: calc(100% - 24px);
  box-sizing: border-box;
  &.disabled {
    background-color: $blue-200;
  }
  &.itallic {
    font-style: italic;
  }
}
.inputLabel {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.input-wrapper input.filled + label,
.input-wrapper label.floated {
  top: 1px;
  padding-top: 2px;
  font-size: 12px;

  background-color: transparent;

  // top: 1;
  // color: #3b82f6;
}
.input-wrapper.textarea-wrapper label.disabled {
  background-color: $gray-blue-600 !important; // $blue-200;
}
.input-wrapper.textarea-wrapper label.floated {
  background-color: $gray-blue-100;
  // color: $blue-1000;
}
.pass-img,
.icon {
  height: 22px;
  font-size: 22px;
  position: absolute;
  right: 8px;
  top: calc(50% - 12px);
  cursor: pointer;
}
.icon {
  cursor: default;
}

/* END FLOAT */
@media only screen and (max-width: 767px) {
  //   .input-wrapper {
  //   position: relative;
  //   display: inline-block;
  //   width: 100%;
  // }

  .input-wrapper input,
  .input-wrapper textarea,
  .input-wrapper .input {
    // width: 100%;
    padding: 15px 12px 4px;
    // box-sizing: border-box;
    height: 45px;
    // border: 1px solid $gray-blue-700;
    // border-radius: 8px;
    // background-color: $gray-blue-100;
    font-size: 14px;
    outline: none;

    font-weight: 400;

    line-height: 14px;
    // letter-spacing: 0%;
    // color: $blue-1000;
  }
  .input-wrapper input[type="password"] {
    padding-right: 40px;
  }

  .input-wrapper textarea {
    padding-top: 20px;
    height: 150px;
  }

  .input-wrapper label {
    text-align: left;
    // position: absolute;
    // left: 12px;
    top: 10px;
    // color: $gray-blue-1300; /* gray-500 */
    font-size: 14px;
    &.itallic {
      font-style: italic;
    }

    // pointer-events: none;
    // transition: 0.2s ease all;
    // background-color: $gray-blue-100;
    // padding: 0;
    // width: calc(100% - 24px);
    // box-sizing: border-box;
  }

  .input-wrapper input.filled + label,
  .input-wrapper label.floated {
    top: 1px;
    padding-top: 0px;
    font-size: 12px;

    background-color: transparent;

    // top: 1;
    // color: #3b82f6;
  }
  .input-wrapper.textarea-wrapper label.floated {
    // background-color: transparent;
    background-color: $gray-blue-100 !important;
  }
  // .pass-img {
  //   height: 22px;
  //   position: absolute;
  //   right: 8px;
  //   top: calc(50% - 12px);
  //   cursor: pointer;
  // }
}
</style>
